export default "Private Ownership has an <b>investor hoarding problem</b>.\n";